module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-smile-upside-down-fill-1142a4dc.svg";